import { createSelector } from 'reselect'

import { FacebookSettingsRootState } from '../facebookSettingsRoot.reducer'

export const getFacebookPage = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.facebookPage,
  (state) => {
    return state
  },
)

export const getAllFacebookCategories = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.categories,
  (state) => {
    return state
  },
)

export const getPotentialPageImprint = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.potentialImprint,
  (state) => {
    return state
  },
)

export const getMediaFileMetadata = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.mediaFileMetadata,
  (state) => {
    return state
  },
)

export const getMediaData = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.mediaFiles,
  (state) => state,
)

export const getCoverImages = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.coverImages,
  (state) => state,
)

export const getProfileImages = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.profileImages,
  (state) => state,
)

export const getProfileMediaFile = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.profileMediaFile,
  (state) => state,
)

export const getCoverMediaFile = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.coverMediaFile,
  (state) => state,
)

export const getUpdateImprintAutomaticallyValue = createSelector(
  (state: FacebookSettingsRootState) => state.facebookStore.updateImprintAutomatically,
  (state) => state,
)

